import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import BaseProfilEcritureMouvement from './BaseProfilEcritureMouvement';

class BaseProfilEcritureRecette extends BaseProfilEcritureMouvement {
	constructor() {
		super();
		this.panels = [new CodeProduitLocalPanel(true)];
	}
}

export default BaseProfilEcritureRecette;
